import { render, staticRenderFns } from "./edit-vessel.vue?vue&type=template&id=057252b5&"
import script from "./edit-vessel.vue?vue&type=script&lang=js&"
export * from "./edit-vessel.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./edit-vessel.vue?vue&type=style&index=1&id=057252b5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports